import { useCallback, useState } from "react";
import MultiItemSelectDropdown from "../inputs/MultiItemSelectDropdown";
import AppContext from "../context/AppContext";
import DateField from "../inputs/DateField";
import TextField from "../inputs/TextField";
import { getTravellers } from "../utils";

export default function EasyOTAFormSafaris({ onSubmit, supplierLoc, supplierSettings }) {
   console.log("supplierLoc", supplierLoc);
   const [submitData, setSubmitData] = useState({
      location: supplierLoc.location,
      rooms: 1,
   });
   const [popupsListeners, setPopupsLisners] = useState([]);
   const [travellers, setTravellers] = useState({});
   const travellersItems = getTravellers(supplierSettings);
   const popupCloseEvent = () => {
      popupsListeners.forEach((handler) => {
         handler();
      });
   };
   const registerPops = useCallback((handler) => {
      setPopupsLisners((prev) => {
         return [...prev, handler];
      });
   }, []);

   const handleOnChange = useCallback(({ name, value }) => {
      setSubmitData((prev) => {
         return {
            ...prev,
            [name]: value,
         };
      });
   }, []);

   const handleSubmit = (ev) => {
      ev.preventDefault();
      console.log("Submit", submitData);
      onSubmit && onSubmit({ ...submitData, travellers });
   };

   return (
      <AppContext.Provider value={{ registerPopupListener: registerPops, popupCloseEvent }}>
         <div className='form'>
            <form action='#' method='post' id='search-form' onSubmit={handleSubmit} autoComplete='off'>
               <div className='fields'>
                  <DateField
                     field='departure_date'
                     label='When'
                     minDate={new Date()}
                     required
                     onChange={handleOnChange}
                  />

                  <MultiItemSelectDropdown
                     field='travellers'
                     label='Travellers'
                     items={travellersItems}
                     data={travellers}
                     settings={supplierSettings}
                     onChange={(selected) => {
                        setTravellers((prev) => {
                           return {
                              ...prev,
                              ...selected,
                           };
                        });
                     }}
                     required
                     validity='You must select atleast 1 adult'
                  />
                  <TextField field='rooms' label='Rooms' min='1' type='number' defaultValue={submitData["rooms"]} />
               </div>
               <button className='btn'>Search</button>
            </form>
         </div>
      </AppContext.Provider>
   );
}
